module.exports = __webpack_public_path__ + "static/img/or-shelf-slope-colorbar.bf551d5.png";